import { useScanDeviceApiDelete } from '@hooks/api/useScanDeviceApiDelete';
import type { HardwareVersion } from 'types/api';

export const useHardwareVersionDelete =
  useScanDeviceApiDelete<HardwareVersion>('/hardware-versions');
